import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth";
import { Login } from "./pages/Login";
import { Shell } from "./components/Shell";
import { Overview } from "./pages/Overview";
import { Projects } from "./pages/Projects";
import { Issues } from "./pages/Issues";
import { IssueDetail } from "./pages/IssueDetail";
import { Funnels } from "./pages/Funnels";
import { Uptime } from "./pages/Uptime";
import { Releases } from "./pages/Releases";
import { Realtime } from "./pages/Realtime";
import { Vitals } from "./pages/Vitals";

export function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="center-screen">
        <div className="spin" />
      </div>
    );
  }

  if (!user) return <Login />;

  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Overview />} />
        <Route path="/realtime" element={<Realtime />} />
        <Route path="/vitals" element={<Vitals />} />
        <Route path="/issues" element={<Issues />} />
        <Route path="/issues/:gid" element={<IssueDetail />} />
        <Route path="/funnels" element={<Funnels />} />
        <Route path="/uptime" element={<Uptime />} />
        <Route path="/releases" element={<Releases />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}
